import { render, staticRenderFns } from "./list_menu_user.vue?vue&type=template&id=4b7714c6&scoped=true&"
import script from "./list_menu_user.vue?vue&type=script&lang=js&"
export * from "./list_menu_user.vue?vue&type=script&lang=js&"
import style0 from "./list_menu_user.vue?vue&type=style&index=0&id=4b7714c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7714c6",
  null
  
)

export default component.exports